
    /**
    * 获取系统用户
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13330 {
  /**
   * (String)
   */
  userName?: string | number;
}
  /**
 * YResult<YListData<AdminUserDto>> :YResult
 */
export class IResid13330 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      userId?: {};
      userName?: {};
      phone?: {};
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13330, IResid13330['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/admin/account/listSystemUser',
        params: data
      }) 
  export default http